import { useIonRouter, IonActionSheet, IonButton, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { newspaperOutline, imageOutline, videocamOutline, createOutline, imagesOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState, Component }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const AddMyContent : React.FC<ContentInterface> = ({ content }) => {

    const router = useIonRouter();

    // add text
    const addContent = () => {
        router.push("/add/post", "forward", "push");
    }

    return (
        <div className="admmy-content">
            <IonItem className="content-wrapper" lines="none">
                <IonAvatar className="ion-margin-top ion-margin-bottom" slot="start">
                    <img src={content.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
                </IonAvatar>
                <IonLabel className="input-bubble ion-activatable ripple-parent" onClick={addContent}>
                    { GetStr(LANGUAGE.TXT_NEW_CONTENT) }
                    <IonRippleEffect></IonRippleEffect>
                </IonLabel>
                <IonIcon slot="end" icon={createOutline} color="medium" size="large" onClick={addContent}></IonIcon>
            </IonItem>
        </div>
    );
};
  
export default AddMyContent;